import { AdminStressTestScreen } from '@/screens/admin/admin-stress-test-screen'

export default function () {
  return <AdminStressTestScreen />
}
